export default __webpack_public_path__ + "static/media/blue-belt.087b4f19.png";